import { isBrowser } from "utils/infrastructure/ssg-utils"

export const isInputFocused = (input?: HTMLInputElement | null) => {
    return isBrowser() && document.activeElement === input
}
